import { render, staticRenderFns } from "./business-information.vue?vue&type=template&id=76b9ca8c"
import script from "./business-information.vue?vue&type=script&lang=js"
export * from "./business-information.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports